<template>
    <div
        class="configure-scale columns is-variable is-mobile is-1-desktop-only"
    >
        <div class="column is-one-quarter-mobile">
            <div class="field">
                <label class="label">X</label>
                <div class="control">
                    <input
                        class="input is-primary"
                        type="number"
                        step="0.01"
                        min="0"
                        :value="
                            (
                                current3DFile.analysedProperties.dimensions.X *
                                objectScale
                            ).toFixed(2)
                        "
                        @change="adjustScale($event, 'x')"
                    />
                </div>
            </div>
        </div>

        <div class="column is-one-quarter-mobile">
            <div class="field">
                <label class="label">Y</label>
                <div class="control">
                    <input
                        class="input is-primary"
                        type="number"
                        step="0.01"
                        min="0"
                        :value="
                            (
                                current3DFile.analysedProperties.dimensions.Y *
                                objectScale
                            ).toFixed(2)
                        "
                        @change="adjustScale($event, 'y')"
                    />
                </div>
            </div>
        </div>

        <div class="column is-one-quarter-mobile">
            <div class="field">
                <label class="label">Z</label>
                <div class="control">
                    <input
                        class="input is-primary"
                        type="number"
                        step="0.01"
                        min="0"
                        :value="
                            (
                                current3DFile.analysedProperties.dimensions.Z *
                                objectScale
                            ).toFixed(2)
                        "
                        @change="adjustScale($event, 'z')"
                    />
                </div>
            </div>
        </div>

        <div class="column is-one-quarter-mobile">
            <div class="field">
                <label class="label">{{
                    $t('checkout.configure.inputLabels.unit')
                }}</label>
                <div class="control">
                    <select v-model="objectUnit" class="input is-primary">
                        <option>mm</option>
                        <option>cm</option>
                        <option>inch</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { eventBus } from '../../events/event-bus';

export default {
    name: 'Configure3DModelScaleUnits',
    computed: {
        ...mapGetters(['current3DFile', 'currentCartItem']),
        objectScale: {
            get() {
                return this.currentCartItem.scale === 0
                    ? ''
                    : this.currentCartItem.scale;
            },
            set(value) {
                if (value === '') {
                    value = '0';
                }
                this.$store.dispatch('updateCurrentCartItem', {
                    scale: parseFloat(value),
                });
            },
        },
        objectUnit: {
            get() {
                return this.current3DFile.givenUnitOfLength;
            },
            async set(value) {
                await this.$store.dispatch('update3DFile', {
                    id: this.current3DFile.id,
                    givenUnitOfLength: value,
                });
            },
        },
    },
    methods: {
        adjustScale(e, dimension) {
            let value = e.target.value;
            let currentDimension;
            switch (dimension) {
                case 'x':
                    currentDimension =
                        this.current3DFile.analysedProperties.dimensions.X;
                    break;
                case 'y':
                    currentDimension =
                        this.current3DFile.analysedProperties.dimensions.Y;
                    break;
                case 'z':
                    currentDimension =
                        this.current3DFile.analysedProperties.dimensions.Z;
            }
            this.objectScale = value / currentDimension;
        },
    },
};
</script>

<style scoped></style>
